import { FormActionType } from '../registro-personas-empresas-lib.model';
export interface CheckTooltipsItem {
  id: number;
  nombre: string;
  selected: boolean;
  disabled: boolean;
  tooltips: string;
}
export interface CheckTooltipsListFormInput {
  action: FormActionType;
  elementosCheck: CheckTooltipsItem[];
}
export function createEmptyCheckTooltipsListFormInput(): CheckTooltipsListFormInput {
  return {
    action: FormActionType.Add,
    elementosCheck: []
  };
}
